module.exports = __webpack_public_path__ + "img/backstageLogo.55a7dd56.png";